
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lucky-prodigist",
      function () {
        return require("private-next-pages/lucky-prodigist/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lucky-prodigist"])
      });
    }
  